{
    "send_email__title": "Envoyer le document au client par e-mail ?",
    "send_email__body": "Un e-mail avec un message standard et le document en pièce jointe au format PDF sera envoyé depuis votre boîte mail au contact enregistré.",

    "toast_confirm_email__title": "Document envoyé par e-mail",
    "toast_confirm_email__body": "Il est désormais aussi consultable dans Enventa",

    "delete_order__title": "Annuler la commande ?",
    "delete_order__body": "La commande ne sera pas enregistrée. Cette action est irréversible.",

    "toast_confirm_delete_order__title": "Commande supprimée",
    "toast_confirm_delete_order__body": "La commande a bien été supprimée",

    "delete_quote__title": "Annuler le devis ?",
    "delete_quote__body": "Le devis ne sera pas enregistré. Cette action est irréversible.",

    "toast_confirm_delete_quote__title": "Devis supprimé",
    "toast_confirm_delete_quote__body": "Le devis a bien été supprimé",

    "action__submit_without_email": "Ne pas envoyer d'e-mail",
    "action__submit_with_email": "Envoyer l'e-mail"
}
